import { render, staticRenderFns } from "./FooterMainLastColumnHook.vue?vue&type=template&id=7157fcb0&"
import script from "./FooterMainLastColumnHook.js?vue&type=script&lang=js&"
export * from "./FooterMainLastColumnHook.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports